import * as S from "./styles";

import { Skeleton } from "../Skeleton";

function MapPopupSkeleton() {
  return (
    <S.Wrapper>
      <S.Container>
        <S.Header>
          <header>
            <S.Title>
              <Skeleton width="10em" height={18} />
            </S.Title>
            <S.CoordinateText>
              <Skeleton width="10em" />
            </S.CoordinateText>
          </header>

          <S.CloseButton type="button">
            <Skeleton width="10em" rounded />
          </S.CloseButton>
        </S.Header>
        <div>
          <S.ButtonContainer>
            <Skeleton style={{ marginBottom: 10 }} height={30} />
            <Skeleton height={30} />
          </S.ButtonContainer>

          <S.WorkingStatus isSkeleton available={false}>
            <S.Info isSkeleton>
              <Skeleton height={30} />
            </S.Info>
          </S.WorkingStatus>
        </div>
      </S.Container>
    </S.Wrapper>
  );
}

export { MapPopupSkeleton };
